import type { NotificationDTO } from '@next-space/fe-api-idl';
import type { FC } from 'react';
import { useCallback, useEffect, useState } from 'react';
import { SPECIAL_SPACE_ID } from 'src/common/const';
import { request } from 'src/common/request';
import { MessageCard } from './message-card';
import type { MessageBoardType } from './type';

interface Props {
  onCloseModal?: () => void;
}

export const MessageBoard: FC<Props> = ({ onCloseModal = () => {} }) => {
  const notifications = useMessageBoardList();

  return (
    <div className="w-full px-4 py-1.5 relative ">
      {notifications.map((notification) => {
        const messageType = notification.edits?.[0]?.messageBoardProperty?.type as MessageBoardType;

        if (!messageType) return null;

        return (
          <MessageCard
            key={notification.uuid}
            messageType={messageType}
            onCloseModal={onCloseModal}
          />
        );
      })}

      {!notifications.length && <div className="text-t4 text-grey6 text-center">暂无使用秘诀</div>}
    </div>
  );
};

export const useMessageBoardList = () => {
  const [notifications, setNotifications] = useState<NotificationDTO[]>([]);

  const fetchNotification = useCallback(async () => {
    const res = await request.editor.getNotificationList(SPECIAL_SPACE_ID, 'messageBoard', 1, 100);
    const notification = (res.notificationIds ?? [])
      .map((uuid) => (res.recordMap ?? {}).notifications?.[uuid])
      .filter((item): item is NotificationDTO => !!item);

    setNotifications(notification);
  }, []);

  useEffect(() => {
    void fetchNotification();
  }, [fetchNotification]);

  return notifications;
};
